// extracted by mini-css-extract-plugin
module.exports = {"detailWrapper":"AlertDataModal_detailWrapper__2QmWE","alertDetail":"AlertDataModal_alertDetail__3T5vM"};